import $ from "jquery";
window.$ = window.jQuery = $;
import "jquery-ajax-unobtrusive";

import { Modal, Tab } from "bootstrap";
import Player from "@vimeo/player";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import { Loader } from "@googlemaps/js-api-loader";
import { pieCharts } from "./_pie-charts";
import { resize } from "./_resize";
import { maps } from "./_maps";
import { navigation } from "./_navigation";
import { SlidingPanel } from "./_sliding-panel";
import { carousel } from "./_carousel";
import { articleSearch } from "./_article-search";
import { contactForm } from "./_contact-form";
import { websitesFilter } from "./_websites-filter";
import { historyBlock } from "./_history-block";
import { videoBlock } from "./_video-block";
import { animations } from "./_animations";

navigation.init();
resize.init();
videoBlock.init();
animations.init();

if ($('.carousel').length) {
	carousel.init();
}

maps.init(new Loader({
	apiKey: "AIzaSyB3txGG7bRi_gb7ySSAGsD4F5gxOuxP2ao"
}));

if ($('div.pie-chart').length) {
	pieCharts.init();
}

if ($('.block-slidingPanelBlock').length) {
	$('.block-slidingPanelBlock').each(function (i, e) {
		let sp = new SlidingPanel(e);
	});	
}

if ($('.articleListingPage').length) {
	articleSearch.init();
	window.articleSearch = articleSearch;
}

if ($('#contact-form').length) {
	contactForm.init();
}

if ($('.websitesPage').length) {
	websitesFilter.init();
}

if ($('.block-historyBlock').length) {
	historyBlock.init();
}

$(function () {

	if ($(window).outerWidth() < 450) {
		$('div[data-mobile-image]').each(function (i, e) {
			$(e).css({ 'background-image': 'url("' + $(e).data("mobile-image") + '")' });
		});
	}

	if ($(window).outerWidth() < 850) {
		$('div[data-tablet-image]').each(function (i, e) {
			$(e).css({ 'background-image': 'url("' + $(e).data("tablet-image") + '")' });
		});
	}

	$('.scale-bg-image').each(function (i, e) {
		if ($(window).outerWidth() > 1400) {
			$(e).css({ 'background-image': 'url("' + $(e).data("bg-src") + '")' });
		} else if ($(window).outerWidth() > 1000) {
			$(e).css({ 'background-image': 'url("' + $(e).data("bg-src") + '?width=1200")' });
		}
	});

	$('.tab-dropdown').each(function (i, e) {
		$(e).on('change', function (dd) {
			let triggerEl = document.querySelector($('option:selected', this).data('click-target'));
			triggerEl.click();
		});
	});

	if ($('.block .block-structuredStatisticBlock').length) {
		$('.block').each(function (i, e) {
			if ($('.set-height', e).length) {
				let maxHeight = 80;
				let items = $('.set-height', e);
				for (var i = 0; i < items.length; i++) {
					if ($(items[i]).outerHeight() > maxHeight) maxHeight = $(items[i]).outerHeight();
				}
				$('.set-height', e).css({ 'height': maxHeight + 'px' });
			}
		});
    }

	if ($('.page-header').length) {

		//if ($(window).outerWidth() < 450) {
		//	$('.page-header').each(function (i, e) {
		//		$(e).css({ 'background-image': 'url("' + $(e).data("mobile-image") + '")' });
		//	});
		//}

		var pos = $('.page-header').position().top + $('.page-header').outerHeight();
		var nbh = $('header > .navbar').outerHeight() + 2;

		$('.sidebar .offcanvas-header').css('height', (nbh + 5) + 'px');

		$('.sidebar-control').css('top', pos + 'px');

		$(window).on('scroll', function () {
			let sp = $(window).scrollTop();
			if (sp < pos && (pos - sp) > nbh) {
				$('.sidebar-control').css('top', (pos - sp) + 'px');
			} else {
				$('.sidebar-control').css('top', nbh + 'px');
			}
		});
		//$('.offcanvas-start').css('top', pos + 'px');
	}

	$('.vimeo-play-button').each(function (i, e) {
		let id = $(this).data('video-wrapper-id');
		if (id != undefined) {
			let player = new Player(id);
			let $that = $(this);
			$(this).on('click', function () {
				player.play();
				$(this).addClass('d-none');
			});
			player.on('pause', function () {
				$that.removeClass('d-none');
			});
		}
	});


	if ($('.home').length) {
		let pips = $('.pips li');
		let panelTops = $('.home > .block');
		let heights = [];
		let ch = 0;
		$(panelTops).each(function (i, e) {
			ch += $(e).outerHeight();
			heights[heights.length] = ch;
		});

		//$('.home').sectionsnap({'animationTime': 100 });
		
		$(window).on('scroll', function () {
			let s = $(window).scrollTop();
			$('.home .indicator-pip').removeClass('active');
			for (var i = 0; i < heights.length; i++) {
				if (s >= heights[i] - 20 && i < heights.length - 1 && s < heights[i + 1] - 20) {
					$('.indicator-pip', pips[i + 1]).addClass('active');
					if (i == heights.length - 2) {
						$('.scroll-helper .helper').fadeOut();
					} else {
						$('.scroll-helper .helper').fadeIn();
					}
					break;
				} 
			}
			if (s < heights[0]-20) {
				$('.indicator-pip', pips[0]).addClass('active');
			}
		});

		var videoTimer = 0;
		var captionIndex = 0;
		if ($('.video-caption').length) {
			const captions = $('.video-caption').data('captions');
			if (captions.length) {
				window.setInterval(function () { videoTimer++; }, 1000);
				// Set first caption
				$('.video-caption').text(captions[captionIndex].caption);
				window.setInterval(() => changeCaption(captions), 100);
			}
		}

		function changeCaption(captions) {
			if (videoTimer >= captions[captionIndex].duration) {
				if (captionIndex == captions.length - 1) {
					captionIndex = 0;
				} else {
					captionIndex++;
				}				
				$('.video-caption').text(captions[captionIndex].caption);
				videoTimer = 0;
			}
		}

		var grid = new Masonry('.home-news', { precentPosition: true });

		imagesLoaded('.home-news', function () {
			grid.layout();
		});
	}

	if ($('.region-select').length) {

		setMapAndIntro($('.region-select'));

		$('.region-select').on('change', function () {
			setMapAndIntro(this);
		});

		function setMapAndIntro(select) {
			let map = $('.world-map', $(select).parents('.container'));
			$('path', map).removeClass('active');
			$('path', '#' + $(select).val()).addClass('active');
			$('.region-intro').removeClass('show').addClass('collapse');
			$('#region_' + $(select).val()).addClass('show').removeClass('collapse');
		}
	}

	if ($('.scroll-icons').length) {
		let width = $('.scroll-holder .scroll-card').parent().outerWidth();
		$('.scroll').on('click', function (evt) {
			evt.preventDefault();
			let scroller = $('.scroll-x', $(this).parents('.scroll-holder'));
			if ($(this).hasClass('left')) {
				scroller.animate({ scrollLeft: scroller.scrollLeft() - width });
			} else {
				scroller.animate({ scrollLeft: scroller.scrollLeft() + width });
			}
		});
	}

	if ($('.block-leadershipBlock').length) {
		
		var startModalIndex = -1, startModalContent = '',
			startExecModalIndex = -1, startExecModalContent = '',
			startTab3ModalIndex = -1, startTab3ModalContent = '';

		$('.block-leadershipBlock .modal').on('click', '.pagination a', function (evt) {
			evt.preventDefault();
			var thisModal = $(this).parents('.modal');
			let index = $(this).data('index');
			var group = $(this).parents('.modal').data('modal-group');//"director,exec,tab3"
		//	var exec = $(this).parents('.modal').hasClass('exec');

			if (group=='exec' && startExecModalIndex == -1) {
				startExecModalContent = $('.modal-content .row', thisModal).html();
				startExecModalIndex = index;
			} else if (group=='director' && startModalIndex == -1) {
				startModalContent = $('.modal-content .row', thisModal).html();
				startModalIndex = index;
			} else if (group == 'tab3' && startTab3ModalIndex == -1) {
				startTab3ModalContent = $('.modal-content .row', thisModal).html();
				startTab3ModalIndex = index;
			}

			let modals = group == 'exec' ? $('.block-leadershipBlock .modal.exec') : group == 'director' ? $('.block-leadershipBlock .modal.director') : $('.block-leadershipBlock .modal.tab3');
			if ($(this).hasClass('previous')) {
				if (index == 0) {
					index = modals.length - 1;
				} else {
					index--;
				}
			} else {
				if (index == modals.length - 1) {
					index = 0;
				} else {
					index++;
				}
			}

			var newModalContent = $('.modal-content .row', modals[index]).html();

			if (group=='exec') {
				if (index == startExecModalIndex) {
					newModalContent = startExecModalContent;
				}
			} else if (group=='director'){
				if (index == startModalIndex) {
					newModalContent = startModalContent;
				}
			} else if (group == 'tab3') {
				if (index == startTab3ModalIndex) {
					newModalContent = startTab3ModalContent;
				}
			}

			//Track the modal change for Lead Forensics
			// We don;t need this (yet?)
			//let url = $(newModalContent).data('trk-url');
			//let name = $(newModalContent).data('trk-name');
			//if (url != null && name != null) {
			//	if (url.substring(url.length, 1) != '/') { url += '/'; }
			//	track_load(window.location.href + url, name);
			//}

			$('.modal-content .row', thisModal).fadeOut(function () { $('.modal-content .row', thisModal).html(newModalContent); $('.modal-content .row', thisModal).fadeIn(); });
		});
	}

	// GA Download tracking events
	if (window.gtag!=undefined) {
		gtag('config', 'GA_MEASUREMENT_ID', { 'transport_type': 'beacon' });

		$('a').filter(function () {
			return this['href'].match("\.(pdf|xlsx|png|docx)$");
		}).on('click', function (evt) {
			var hrs = $(this).attr('href')?.split('/');
			var filename = hrs!=null ? hrs[hrs.length - 1] : '';
			gtag('event', 'Download', {
				'event_category': 'Link',
				'event_label': $(this).text() + ' [' + filename + ']',
				//'event_callback': function () { window.open($(this).attr('href'), target = $(this).attr('target')); }
			});
		});
	}

	// Extra click tracking for Lead Forensics
	function track_load(docloc, doctit) {
		var trk_sw = escape(screen.width).substring(0, 6);
		var trk_sh = escape(screen.height).substring(0, 6);
		var trk_ref = escape(document.referrer).substring(0, 1100);
		var trk_tit = escape(doctit).substring(0, 200);
		trk_tit = trk_tit.replace(/\%u00a0/g, '');
		trk_tit = trk_tit.replace(/\%u2122/g, '');
		trk_tit = trk_tit.replace(/\%u[0-9][0-9][0-9][0-9]/g, '');
		var trk_loc = escape(docloc).substring(0, 200);
		var trk_agn = escape(navigator.appName).substring(0, 100);
		var trk_agv = escape(navigator.userAgent + '.lfcd' + screen.colorDepth + '.lflng').substring(0, 1000);
		var trk_dom = escape(document.domain).substring(0, 200);
		var trk_user = '795593';
		var trk_cookie = '';
		var trk_guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
		var trk_img = 'https://secure.leadforensics.com/Track/Capture.aspx';
		var trk_link = trk_img + '?trk_user=' + trk_user + '&trk_sw=' + trk_sw + '&trk_sh=' + trk_sh + '&trk_ref=' + trk_ref + '&trk_tit=' + trk_tit + '&trk_loc=' + trk_loc + '&trk_agn=' + trk_agn + '&trk_agv=' + trk_agv + '&trk_dom=' + trk_dom + '&trk_guid=' + trk_guid + '&trk_cookie=NA';
		var preload = new Image();
		preload.src = trk_link;
	}

	$('.track-me').on('click', function (evt) {
		let url = $(this).data('trk-url');
		let name = $(this).data('trk-name');
		if (url != null && name != null) {
			if (url.substring(url.length, 1) != '/') { url += '/'; }
			track_load(window.location.href + url, name);
		}
	})
})